import * as React from 'react';

import { Layout, LayoutBlock, Main, MainContent } from '../../components/Page';
import { BankListContainer } from '../BankList';
import { BannerContainer } from '../BannerContainer';
import { CategoriesContainer } from '../CategoriesContainer';
import { FreshPromoListContainer } from '../FreshPromoList';
import { HeadCategoriesContainer } from '../HeadCategoriesContainer';
import { LowRateMortgagePromosContainer } from '../LowRateMortgagePromosContainer';
import { MortgageContainer } from '../MortgageContainer';
import { PageHeaderContainer } from '../PageHeaderContainer';
import { PromoCompilationsContainer } from '../PromoCompilation';

export const PageContainer: React.FC = () => {
  return (
    <Main>
      <Layout>
        <PageHeaderContainer />
      </Layout>
      <MainContent>
        <LayoutBlock>
          <HeadCategoriesContainer />
        </LayoutBlock>
        <LayoutBlock>
          <LowRateMortgagePromosContainer />
        </LayoutBlock>
        <LayoutBlock>
          <BankListContainer />
        </LayoutBlock>
        <LayoutBlock>
          <BannerContainer />
        </LayoutBlock>
        <LayoutBlock>
          <FreshPromoListContainer />
        </LayoutBlock>
        <LayoutBlock>
          <PromoCompilationsContainer />
        </LayoutBlock>
        <LayoutBlock>
          <MortgageContainer />
        </LayoutBlock>
        <LayoutBlock>
          <CategoriesContainer />
        </LayoutBlock>
      </MainContent>
    </Main>
  );
};
